import React, { useState } from 'react';
import { AlertColor, Box } from '@mui/material';
import { AlertBox } from '../../../AlertBox';
import { AlertBoxTitle } from '../../../AlertBox/AlertBoxTitle';

interface ErrorBoundaryAlertProps {
  title: string;
  error: Error;
  fallbackErrMessage: string;
  resetError?: () => void;
  pathname: string;
  severity?: AlertColor;
}

/**
 * Renders an error boundary alert and resets it on pathname change
 * @param title - error alert title
 * @param error - the error object
 * @param fallbackErrMessage - a fallback error string
 * @param resetError - function used to reset/clear error alert
 * @param pathname - the current location pathname
 * @param severity - optional severity AlertColor, defaults to error
 */
export const ErrorBoundaryAlert: React.FC<React.PropsWithChildren<ErrorBoundaryAlertProps>> = ({
  title,
  error,
  fallbackErrMessage,
  resetError,
  pathname,
  severity = 'error',
}: ErrorBoundaryAlertProps) => {
  const [errorSourcePathname] = useState(pathname);
  if (errorSourcePathname !== pathname && !!resetError) resetError();

  return (
    <AlertBox alertType={severity} data-testid="error-alert-component">
      <AlertBoxTitle>{title}</AlertBoxTitle>
      <Box sx={{ wordBreak: 'break-word' }}>{error && error.toString() ? error.toString() : fallbackErrMessage}</Box>
    </AlertBox>
  );
};
